import * as React from 'react';
import {Page} from '../../types/PageInfo';
import {Link, LinkProps} from 'react-router-dom';

import {Tooltip} from 'antd';
import Flex from '../StyledComponents/Flex';
import {isNullOrUndefined} from "../../utils";
import {useTranslation} from "@nic-react-i18n/core";

// import { CSSProperties } from 'react';

interface ElementsInfoInterface {
    icon: React.ReactElement<any>;
    label: string;
    info: Page;
    url: string;
    fontSize?: string;
}

type ElementsInfoProp = ElementsInfoInterface;

interface LinkableInterface {
    disabled: boolean;
}

const Linkable: React.FC<LinkProps & LinkableInterface> = (props) => {
    let component;
    if (props.disabled) {
        component = <span>{props.children}</span>;
    } else {
        component = <Link to={props.to}>{props.children}</Link>;
    }
    return (
        component
    );
};

const ElementsInfo: React.FC<ElementsInfoProp> = (props) => {
    const {fontSize} = props;
    const {t} = useTranslation()

    let size = (isNullOrUndefined(fontSize) ? '2vw' : fontSize);

    return (
        <Flex
            direction={'column'}
            justify={'center'}
            align={'center'}
        >
            <Tooltip title={t(`dashboard.link.${props.label}`)}>
                <div>
                <Linkable to={props.url} disabled={props.info.totalElements === 0}>
                    <Flex
                        direction={'row'}
                        align={'center'}
                        onClick={(e: any) => {
                           if (props.info.totalElements === 0) {
                            e.stopPropagation();
                            }
                        }}
                        style={{
                            cursor: (props.info.totalElements === 0 ? 'not-allowed' : 'pointer' ),
                        }}
                    >
                        <div
                            style={{
                                fontSize: size,
                                paddingRight: '10px'
                            }}
                        >
                            {props.icon}
                        </div>
                        <div
                            style={{
                                fontWeight: 300,
                                fontSize: size,
                                color: 'black'
                            }}
                        >
                            {props.info.totalElements}
                        </div>
                    </Flex>
                </Linkable>
                </div>
            </Tooltip>
        </Flex>
    );
};

export default ElementsInfo;